// extracted by mini-css-extract-plugin
module.exports = {"formBody":"Registration_formBody__3NQnx","register":"Registration_register__2H8fr","errorBox":"Registration_errorBox__2OwPJ","successBox":"Registration_successBox__2jQeB"};